import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import StageIconSvg from './stage-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StageIconSvg {...validProps} />;
}
SvgComponent.iconName = 'stageIcon';

/**
 * @deprecated This is a legacy icon
 */
export const StageIcon = svgIconWrapper(SvgComponent);
